// Intercept all alert() calls and replace them with a custom alert box
document.addEventListener("DOMContentLoaded", function () {
    (function () {
        // Create modal elements
        const alertBackdrop = document.createElement('div');
        alertBackdrop.className = 'custom-alert-backdrop';

        const alertBox = document.createElement('div');
        alertBox.className = 'custom-alert-box';

        const alertMessage = document.createElement('div');
        alertMessage.className = 'custom-alert-message';

        const alertButton = document.createElement('button');
        alertButton.className = 'custom-alert-button';
        alertButton.textContent = 'OK';

        alertBox.appendChild(alertMessage);
        alertBox.appendChild(alertButton);
        alertBackdrop.appendChild(alertBox);
        document.body.appendChild(alertBackdrop);

        // Show/hide logic
        function showCustomAlert(message) {
            alertMessage.textContent = message;
            alertBackdrop.style.display = 'flex';

            return new Promise((resolve) => {
                alertButton.onclick = () => {
                    alertBackdrop.style.display = 'none';
                    resolve();
                };
            });
        }

        // Override native alert
        window.alert = async function (message) {
            await showCustomAlert(message);
        };
    })();
});